const routes = [{
  path: '/dataManage',
  component: () => import('@/views/feiche/index'),
  name: 'data-manage',
  meta: {
    title: ''
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/dataManage/dataManage.js